export default __webpack_public_path__ + "static/media/Fitness-Tracker-img-1.dd4e980d.jpg";